module.exports = __webpack_public_path__ + "img/img8.5c8e3211.jpg";